const GSI_SRC = "https://accounts.google.com/gsi/client";

let loadPromise: Promise<void> | null = null;

/**
 * Loaded lazily (only when an auth screen mounts) rather than from index.html
 * so it is not fetched on every page.
 */
export function loadGoogleIdentityScript(): Promise<void> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    if (window.google?.accounts?.id) {
      resolve();
      return;
    }

    let script = document.querySelector<HTMLScriptElement>(
      `script[src="${GSI_SRC}"]`
    );
    const isNew = !script;
    if (!script) {
      script = document.createElement("script");
      script.src = GSI_SRC;
      script.async = true;
      script.defer = true;
    }

    const onLoad = () => resolve();
    const onError = () => {
      loadPromise = null;
      script?.removeEventListener("load", onLoad);
      script?.removeEventListener("error", onError);
      // Drop the failed tag so a later mount re-injects a fresh one: a new
      // listener on a script that already errored would never fire.
      if (isNew) script?.remove();
      reject(new Error("Failed to load Google Identity Services"));
    };

    script.addEventListener("load", onLoad);
    script.addEventListener("error", onError);

    if (isNew) document.head.appendChild(script);
  });

  return loadPromise;
}
